import { Injectable } from "@angular/core";
import { AuthService } from "src/app/_services";
import { ArchitectService } from "src/app/_services/architect.service";

@Injectable()
export class IdentifySegement {

  public currentUser;
  public user;
  public licences={
    plus : "Pro",
		premium : "Intégral",
		base : "Essentiel",
    without:"Aucun",
		"plus-trim" : "Pro-Annuel",
		"plus-annuel" : "Pro-Annuel",
		"premium-annuel" : "Intégral-Annuel",
    "premiumn" : "New Intégral-mensuel",
    "premiumn-trim" : "New Intégral-annuel",
    "premiumn-annuel" : "New Intégral-annuel",
    "max" : "Max-mensuel",
    "max-trim" : "Max-annuel",
    "max-annuel" : "Max-annuel",
    "premiumn-contractor-general-trim" : "New Intégral-contractor-general-trim",
    "premiumn-contractor-general-annuel" : "New Intégral-contractor-general-annuel",
  };
  constructor(private architectService:ArchitectService,
              private authService: AuthService){
  }
  ngOnInit(): void {
    
  }
  identifyLoginArchi(){
      this.architectService.getUserInfoSegment().subscribe(
        data=>{
          let parrainCountUser=0,parrainCountArchi=0
          this.user=data.user;
          data.parrain.forEach(element => {
            if(element.registered && element.parrainUser==this.authService.currentUser.id) parrainCountUser++
            if(element.registered) parrainCountArchi++
          });
          window.analytics.identify(this.user._id, {
            id:this.user._id,
            email: this.user.email,
            firstName: this.user.firstName,
            lastName:this.user.lastName,
            phone:this.user.phone,
            // licence:(this.user.dateEndTrial)?'Essai gratuit':(this.licences[this.user.licence]||'Aucune'),
            type:"architect",
            is_registered:true,
            licence_offered:null,
            last_connection:new Date(),
            number_accounts_sponsored_user:parrainCountUser,
            number_accounts_sponsored_archi:parrainCountArchi,
            company_name:data.archi.name,
            number_of_collaborators:data.archi.users.length-1,
            admin_profile:`admin.bam.archi/#/architect/${this.user.archiID}/project`,
          });
          window.analytics.alias(this.user.email)
        }
    )
  }
  identifySignUp(parrain){
      this.architectService.getUserInfoSegment().subscribe(
        data=>{
          let parrainCountArchi=0
          this.user=data.user;
          data.parrain.forEach(element => {
            if(element.registered) parrainCountArchi++
          });
          window.analytics.identify(this.user._id, {
            id:this.user._id,
            email: this.user.email,
            firstName: this.user.firstName,
            lastName:this.user.lastName,
            phone:this.user.phone,
            licence:'Essai gratuit',
            type:"architect",
            is_registered:true,
            licence_offered:null,
            sponsored:(parrain) ? true:false,
            last_connection:new Date(),
            number_accounts_sponsored_user:0,
            number_accounts_sponsored_archi:parrainCountArchi,
            company_name:data.archi.name,
            number_of_collaborators:data.archi.users.length-1,
            createdAt:new Date(),
            lifetime_value:0,
            status:'Trial',
            admin_profile:`admin.bam.archi/#/architect/${this.user.archiID}/project`,
          });
          window.analytics.alias(this.user.email)
        }
    )
  }
  identifyLicence(newPrice,plan){
    window.analytics.identify(this.authService.currentUser.id, {
      churn_date:null,
      churn_reason:null,
      churn_mrr:0,
      MRR:newPrice,
      licence:this.licences[plan],
      status:'Paying',
    })
  }
  identifyChurnedRaison(churn,oldPrice,newPrice){
    window.analytics.identify(this.authService.currentUser.id, {
      churn_date:new Date(),
      churn_reason:churn,
      churn_mrr:oldPrice,
      MRR:newPrice,
      licence:this.licences['without'],
      status:'Churn', 
    })
  }
  identifyNumCollabs(numCollabs){
    window.analytics.identify(this.authService.currentUser.id, {
      number_of_collab_invites:numCollabs,
    })
  }
  identifyNumUsers(numCollabs){
    window.analytics.identify(this.authService.currentUser.id, {
      number_of_collaborators:numCollabs,
    })
  }
  identifyNumRequestsArtisan(numRequests){
    window.analytics.identify(this.authService.currentUser.id, {
      requests_for_artisans:numRequests.numOfRequests
    })
  }
  identifyNumProjects(numProject){
    window.analytics.identify(this.authService.currentUser.id, {
      number_of_dpgf:numProject,
    })
  }
}